export const GOOGLE_MAP_CHANNELS = {
  ADDRESS_AU: 20,
  ADDRESS_UK: 21,
  FORM_IO_ADDRESS: 22,
};

export const GOOGLE_MAP_API_URLS = {
  AU: `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_KEY}&libraries=places&channel=${GOOGLE_MAP_CHANNELS.ADDRESS_AU}`,
  UK: `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_KEY}&libraries=places&channel=${GOOGLE_MAP_CHANNELS.ADDRESS_UK}`,
};

export const SIGNATURE_STATUSES = {
  UNKNOWN_SIGNATURE_STATUS: 'UNKNOWN_SIGNATURE_STATUS',
  REQUESTED: 'REQUESTED',
  UPDATE_REQUESTED: 'UPDATE_REQUESTED',
  SIGNED: 'SIGNED',
  PARTIALLY_SIGNED: 'PARTIALLY_SIGNED',
  CANCELLED: 'CANCELLED',
};

export const DEFAULT_SIGNER_ROLE_NAME = 'Team member';

export const DOCUMENT_STATUSES = {
  SUBMITTED: 'DOCUMENT_SUBMITTED',
  TODO: 'DOCUMENT_TODO',
  IN_PROGRESS: 'DOCUMENT_IN_PROGRESS',
  // Note BE doesn't have error state but this is internal FE logical state
  // when there is any error while saving document
  ERROR: 'DOCUMENT_ERROR',
};

export const MUTATIONS = {
  SET_DOCUMENT_STATUSES: 'setDocumentStatuses',
};

export const EVENT_NAMES = {
  ONBOARDING_TAX_AND_SUPER_OPENED: 'ONBOARDING_TAX_AND_SUPER_OPENED',
  ONBOARDING_TAX_AND_SUPER_EMBED_LOADED:
    'ONBOARDING_TAX_AND_SUPER_EMBED_LOADED',
  ONBOARDING_TAX_AND_SUPER_EMBED_LOAD_FAILED:
    'ONBOARDING_TAX_AND_SUPER_EMBED_LOAD_FAILED',
  ONBOARDING_TAX_AND_SUPER_FINISHED: 'ONBOARDING_TAX_AND_SUPER_FINISHED',
  ONBOARDING_SUBMIT_REQUESTED: 'ONBOARDING_SUBMIT_REQUESTED',
  ONBOARDING_SUBMIT_SUCCESS_ACKNOWLEDGED:
    'ONBOARDING_SUBMIT_SUCCESS_ACKNOWLEDGED',
  ONBOARDING_SUBMIT_FAILURE_ACKNOWLEDGED:
    'ONBOARDING_SUBMIT_FAILURE_ACKNOWLEDGED',
};

export const EVENT_SCREENS = {
  SUPER_STEP: 'Tax and Super',
  ONBOARDING_REVIEW: 'Onboarding Review Step',
};
